import { useEffect, useState } from "react";
import { TabBar } from "../components/TabBar";
import { TopBar } from "../components/TopBar";
import { api } from "../api/client";
import type { ScheduleEntry, WorkoutTemplate } from "../api/types";

const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const Schedule = () => {
  const [entries, setEntries] = useState<ScheduleEntry[]>([]);
  const [templates, setTemplates] = useState<WorkoutTemplate[]>([]);
  const [tpl, setTpl] = useState("");
  const [day, setDay] = useState(DAYS[0]);

  const load = async () => {
    const [s, t] = await Promise.all([
      api<ScheduleEntry[]>("/schedule"),
      api<WorkoutTemplate[]>("/templates"),
    ]);
    setEntries(s);
    setTemplates(t);
    if (!tpl && t[0]) setTpl(t[0].id);
  };

  useEffect(() => {
    void load();
  }, []);

  const add = async () => {
    if (!tpl) return;
    await api("/schedule", {
      method: "POST",
      body: { templateId: tpl, recurring: true, dayOfWeek: day },
    });
    await load();
  };

  const remove = async (id: string) => {
    await api(`/schedule/${id}`, { method: "DELETE" });
    await load();
  };

  const tplName = (id: string) => templates.find((t) => t.id === id)?.name ?? id;

  return (
    <>
      <div className="page">
        <TopBar title="Schedule" back />

        <div className="card">
          <div className="muted" style={{ marginBottom: 6 }}>Add a recurring workout</div>
          <select value={tpl} onChange={(e) => setTpl(e.target.value)}>
            {templates.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
          <select value={day} onChange={(e) => setDay(e.target.value)} style={{ marginTop: 8 }}>
            {DAYS.map((d) => (
              <option key={d} value={d}>
                Every {d}
              </option>
            ))}
          </select>
          <button className="btn" style={{ marginTop: 12 }} onClick={() => void add()}>
            Add
          </button>
        </div>

        <h2 className="h2">Weekly plan</h2>
        {DAYS.map((d) => (
          <div key={d} className="card">
            <div className="row">
              <strong style={{ textTransform: "capitalize" }}>{d}</strong>
              <div className="spacer" />
              <div className="muted">
                {entries.filter((e) => e.recurring && e.dayOfWeek === d).length === 0 && "—"}
              </div>
            </div>
            {entries
              .filter((e) => e.recurring && e.dayOfWeek === d)
              .map((e) => (
                <div className="row" key={e.id} style={{ marginTop: 8 }}>
                  <span>{tplName(e.templateId)}</span>
                  <div className="spacer" />
                  <button className="btn small secondary" onClick={() => void remove(e.id)}>
                    Remove
                  </button>
                </div>
              ))}
          </div>
        ))}
      </div>
      <TabBar />
    </>
  );
};
